<template>
  <div id="functionPageWrapper">
    <div id="page">
      <router-view />
    </div>

    <MessageDialogue v-if="showMessage" />
    <ErrorDialogue v-if="showError" />
    <RegistrationFullDialogue v-if="isRegistrationFull" />

    <Navigation />
  </div>
</template>

<script setup>
import { computed } from 'vue';

import ErrorDialogue from '@/components/dialogue/ErrorDialogue.vue';
import MessageDialogue from '@/components/dialogue/MessageDialogue.vue';
import RegistrationFullDialogue from '@/components/dialogue/RegistrationFullDialogue.vue';
import Navigation from '@/components/navigation/NavigationIndex.vue';
import useMessagesStore from '@/stores/messages';

const MessagesStore = useMessagesStore();

const showMessage = computed(() => {
  return MessagesStore.hasMessage;
});

const showError = computed(() => {
  return MessagesStore.hasError;
});

const isRegistrationFull = computed(() => {
  return MessagesStore.isRegistrationFull;
});
</script>

<style scoped>
#functionPageWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
